import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar os tipos de revenda.
 *
 * @param {string} authToken - Token de autenticação do usuário.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 * A resposta é um array de objetos.
 */
export function fetchTipoRevendaListar({
  enabled,
  authToken,
}: {
  enabled?: boolean;
  authToken: string;
}): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/TipoRevenda/ListarPorFiltro";
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, {}, config);
    return response?.data?.data?.response;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-tipo-revenda-listar"],
    enabled: enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}
